export const PREVIEW = {
   TEXT: 'text',
   USERINPUT: 'userinput',
   DELAY: 'delay',
   IMAGE: 'image',
   GALLERY: 'gallery'
}